import React from 'react';
import './contactus.css';

const ContactUs = () => {

  const contactData = [
    {
      name: 'Sunil Patel',
      contactNumber: '+1-909-709-2876',
      email: 'sunil.patel@globalmgmtinc.net',
    },
    {
      name: 'Nayan Patel',
      contactNumber: '+1-951-317-2760',
      email: 'nayan.patel@globalmgmtinc.net',
    },
    {
      name: 'Arun Patel',
      contactNumber: '+1-909-556-3871',
      email: 'arun.patel@globalmgmtinc.net',
    },
    {
      name: 'Parth Patel',
      contactNumber: '+1-951-893-7247',
      email: 'parth.patel@globalmgmtinc.net',
    },
    {
      name: 'Roshan Patel',
      contactNumber: '+1-951-255-6193',
      email: 'roshan.patel@globalmgmtinc.net',
    },
    
  ];

  return (
    <div className="contact-us-container">
      <h2>Contact Us</h2>
      <div>
          <p>
            For general inquires, please contact at <a href={`mailto:management@globalmgmtinc.net`}>management@globalmgmtinc.net</a>
          </p>
        </div>
        <br />
        <br />
        <br />
        <p>
          For additional inquires, please contact one of the following
        </p>
      <div className="contact-list">
        {contactData.map((contact:any, index:any) => (
          <div key={index} className="contact-card">
            <h3>{contact.name}</h3>
            <p>
              <span className="label">Contact Number:</span> {contact.contactNumber}
            </p>
            <p>
              <span className="label">Email:</span> <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactUs;